import Vue from 'vue'
import {
  resolve,
  browse,
  to,
  go,
  close,
  reload,
} from '@/api/browser'

async function carregarRevisao() {
  try {
    const response = await fetch('/REVISAO.txt');
    if (response.ok) {
      var value = await response.text();
      // Remover linhas comentadas com #, // ou --
      value = value.replace(/^(#|\/\/|--).*/gm, '');
      // Remover quebras de linha.
      value = value.replace(/\r?\n|\r/g, '');
      return value
    } else {
      console.warn('Erro ao carregar revisão:', response.statusText);
      return '0.0.1';
    }
  } catch (error) {
    console.error('Erro ao carregar revisão:', error);
    return '0.0.1';
  }
}

const plugin = {
  async install(Vue) {
    Vue.prototype.$resolve = resolve
    Vue.prototype.$browse = browse
    Vue.prototype.$to = to
    Vue.prototype.$go = go
    Vue.prototype.$close = close
    Vue.prototype.$reload = reload
    
    Vue.prototype.$revisao = await carregarRevisao(); // Aguarde a resolução da Promise
  }
}

Vue.use(plugin)

